<i18n>
{
  "fr": {
    "title": "Détail du formulaire Conformité",
    "conformite": "Conformité - N°{number}",
    "typeOfVisit": "Type de visite :",
    "dateOfVisit": "Date de visite :",
    "protractor": "Rapporteur :",
    "activiteGarageLavage": "Activité type garage, station de lavage, etc. :",
    "typeOfControl": "Type de contrôle :",
    "proprieteNonRaccordeAssainissement": "La propriété est raccordée à un réseau public d’assainissement",
    "eauxPluvialeNonRaccordeAssainissement": "Les eaux pluviales de la propriété sont raccordées à un réseau d’eaux pluviales",
    "domesticReject": "Rejets domestiques",
    "eauxUseesEtPluvialesSeparees": "Les eaux usées et eaux pluviales sont séparées jusqu’en limite de propriété :",
    "raccordementEuEp": "Raccordement EU dans EP",
    "raccordementEuEpExistant": "Semble envisageable de reconnecter les EU à un branchement EU existant",
    "raccordementEuEpNew": "Semble nécessaire de faire une demande de réalisation d’un branchement neuf EU",
    "estimatedNumberOfResident": "Estimation du nombre d’équivalent habitant :",
    "raccordementEpEu": "Raccordement EP dans EU",
    "numeroRaccordementEpEu": "Numéro de branchement EP dans EU :",
    "numeroRaccordementEuEp": "Numéro de branchement EU dans EP :",
    "infiltrerPartieEP": "Semble envisageable d’infiltrer tout ou une partie des EP",
    "recupererPartieEP": "Semble envisageable de récupérer toute une partie des EP",
    "reconnecterEpGargouille": "Semble envisageable de reconnecter les EP à une gargouille existante",
    "reconnecterEpExistEp": "Semble envisageable de reconnecter les EP à un branchement EP existant",
    "realisationBranchementEpNeuf": "Semble nécessaire de faire une demande de réalisation d’un branchement neuf EP",
    "reseauSeparatif": "Réseau séparatif",
    "surfaceParcelle": "Surface de la parcelle (m²) :",
    "surfaceCollecte": "Surface collectée par la grille connectée aux EU (m²) :",
    "derogationAccorde": "Dérogation accordée car les eaux pluviales sont raccordées au réseau d’eaux usées uniquement par une grille ou un siphon récupérant les EP de surfaces n’excédant pas 10% de la surface totale de la parcelle, dans la limite de 20 m²",
    "eauxUseesTransitentGouttiere": "Des eaux usées transitent par la gouttière :",
    "eauxUseesProlongeesEvents": "Les descentes d’eaux usées sont prolongées d’évents :",
    "eauxUseesRaccordeesRpu": "L’ensemble des eaux usées est raccordé à un réseau public unitaire ou d’eaux usées :",
    "etancheiteRespectee": "L’étanchéité des installations est respectée (uniquement pour les canalisations contrôlées) :",
    "sanitairesSiphonne": "L’ensemble des appareils sanitaires est siphonné :",
    "sanitairesSousNiveauChaussee": "Des installations sanitaires sont situées sous niveau de chaussée :",
    "installationProtectionReflux": "Ces installations sont équipées d’un système de protection contre le reflux :",
    "appareilsInterditReglement": "Il existe un (ou des) appareil(s) interdit(s) par le Règlement du Service :",
    "appareilsInterditReglementText": "Lesquels :",
    "gestionEpParcelle": "Présence d’un (ou plusieurs) ouvrage(s) de gestion des eaux pluviales à la parcelle :",
    "gestionEpParcelleSelection": "Lesquels :",
    "rejetDomestiqueBonFonctionnement": "En bon fonctionnement :",
    "rejetDomestiqueAccessible": "Accessible(s) :",
    "rejetDomestiqueEntretenu": "Entretenu(s) (pièces justificatives) :",
    "rejetDomestiqueRemarque": "Autres remarques :",
    "rejetNonDomestique": "Rejets non-domestiques",
    "activiteRestauration": "Activité de restauration :",
    "parking": "Parking :",
    "parkingNbPlace": "Nombre de places :",
    "autreActiviteNonDomestiques": "Autre activité non-domestique :",
    "autreActiviteNonDomestiquesText": "Laquelle :",
    "equipementsPretraitement": "Il existe un (ou des) équipement(s) de prétraitement :",
    "equipementsPretraitementSelection": "Lesquels :",
    "infoEquipement": "Ce(s) équipement(s) est(sont)",
    "rejetNonDomestiqueBonFonctionnement": "En bon fonctionnement :",
    "rejetNonDomestiqueAccessible": "Accessible(s) :",
    "rejetNonDomestiqueEntretenu": "Entretenu(s) (pièces justificatives) :",
    "rejetNonDomestiqueRemarque": "Autres remarques :",
    "controleRemarque": "Autres remarques sur le contrôle :",
    "resume": "Conclusion",
    "cancel": "Retour",
    "typeOfInvestigation":"Type enquête :",
    "signature": "Signature",
    "technical_drawings": "Dessin Technique",
    "technical": "Technique",
    "synoptic": "Synoptique",
    "download": "Télécharger",
    "deleteControl": "Supprimer le contrôle",
    "editControl": "Éditer le contrôle",
    "delete_control_confirmation_message": "Attention ! Vous vous apprêtez à supprimer le contrôle. La suppression est définitive. Le contrôle sera effacée de la base. Apres validation de la suppression, il ne sera plus possible de revenir en arrière. Vous confirmez ?"
  }
}
</i18n>
<template>
  <b-row>
    <b-col>
      <InfoBar :title="this.$i18n.t('title')">
        <template v-slot:cancelbtn>
          <b-link
            class="btn s-btn-b btn-gray mg-r-15 pull-right"
            @click="onCancel"
          >{{ $t('cancel') }}</b-link>
        </template>
      </InfoBar>
      <hr />
      <WorkflowTimeline />
      <FileDetail
        :photos="conformiteForm.photos"
        :schemas="conformiteForm.schemas"
        :technicalFiles="conformiteForm.technicalFiles"
        :reports="conformiteForm.reports"
        :others="conformiteForm.others"
      />
      <div class="panel panel-info text-left">
        <div class="panel-heading">{{ $t('conformite', { number: property.folderNumber }) }}</div>
        <div class="panel-body">
          <div>
            <p class="text">
              {{ $t('dateOfVisit') }}
              <span>{{ formatDate(conformiteForm.dateOfVisit) }}</span>
            </p>
            <p class="text">
              {{ $t('protractor') }}
              <span>{{ conformiteForm.protractor }}</span>
            </p>

            <p class="text">
              {{ $t('typeOfInvestigation') }}
              <span>{{ getTypeOfInvestigation(conformiteForm.typeOfInvestigation) }}</span>
            </p>
            <p class="text">
              {{ $t('typeOfVisit') }}
              <span>{{ getValueOf(conformiteForm.typeOfVisit) }}</span>
            </p>
            <p class="text">
              {{ $t('typeOfControl') }}
              <span>{{ getTypeOfControl(conformiteForm.typeOfControl) }}</span>
            </p>
            <p class="text">
              <template v-if="this.getValue(conformiteForm.proprieteNonRaccordeAssainissement)">
                <v-icon name="check" />
              </template>
              <template v-else>
                <v-icon name="times" class="nok" />
              </template>
              {{ $t('proprieteNonRaccordeAssainissement') }}
            </p>
            <p class="text">
              <template v-if="this.getValue(conformiteForm.eauxPluvialeNonRaccordeAssainissement)">
                <v-icon name="check" />
              </template>
              <template v-else>
                <v-icon name="times" class="nok" />
              </template>
              {{ $t('eauxPluvialeNonRaccordeAssainissement') }}
            </p>
          </div>

              <p class="text">
                {{ $t('eauxUseesEtPluvialesSeparees') }}
                <span>{{ getValueOf(conformiteForm.eauxUseesEtPluvialesSeparees) }}</span>
              </p>
              <div

              >
                <p class="text">
                  <template v-if="this.getValue(conformiteForm.raccordementEuEp)">
                    <v-icon name="check" />
                  </template>
                  <template v-else>
                    <v-icon name="times" class="nok" />
                  </template>
                  {{ $t('raccordementEuEp') }}
                </p>
                <div
                  class="block"
                  v-if="conformiteForm.raccordementEuEp == isShown('raccordementEuEp')"
                >
                  <p class="text">
                    <template
                      v-if="conformiteForm.numeroRaccordementEuEp && 0 < conformiteForm.numeroRaccordementEuEp.length"
                    >
                      <p v-for="numeroRaccordementEuEp in conformiteForm.numeroRaccordementEuEp"
                         :key="numeroRaccordementEuEp.id"
                         class="text"
                      >
                        <v-icon name="check" />{{ $t('numeroRaccordementEuEp') }} {{ numeroRaccordementEuEp.label }}
                      </p>
                    </template>
                    <template v-else>
                      <p class="text">
                        <v-icon name="times" class="nok" />
                        {{ $t('numeroRaccordementEuEp') }}
                      </p>
                    </template>
                  </p>
                  <p class="text">
                    <template v-if="this.getValue(conformiteForm.raccordementEuEpExistant)">
                      <v-icon name="check" />
                    </template>
                    <template v-else>
                      <v-icon name="times" class="nok" />
                    </template>
                    {{ $t('raccordementEuEpExistant') }}
                  </p>
                  <p class="text">
                    <template v-if="this.getValue(conformiteForm.raccordementEuEpNew)">
                      <v-icon name="check" />
                    </template>
                    <template v-else>
                      <v-icon name="times" class="nok" />
                    </template>
                    {{ $t('raccordementEuEpNew') }}
                  </p>
                  <p class="text">
                    {{ $t('estimatedNumberOfResident') }}
                    <span>{{ conformiteForm.estimatedNumberOfResident }}</span>
                  </p>
                </div>
                <p class="text">
                  <template v-if="this.getValue(conformiteForm.raccordementEpEu)">
                    <v-icon name="check" />
                  </template>
                  <template v-else>
                    <v-icon name="times" class="nok" />
                  </template>
                  {{ $t('raccordementEpEu') }}
                </p>
                <div
                  class="block"
                  v-if="conformiteForm.raccordementEpEu == isShown('raccordementEpEu')"
                >
                  <p class="text">
                    <template
                      v-if="conformiteForm.numeroRaccordementEpEu && 0 < conformiteForm.numeroRaccordementEpEu.length"
                    >
                      <p v-for="numeroRaccordementEpEu in conformiteForm.numeroRaccordementEpEu"
                         :key="numeroRaccordementEpEu.id"
                         class="text"
                      >
                        <v-icon name="check" />{{ $t('numeroRaccordementEpEu') }} {{ numeroRaccordementEpEu.label }}
                      </p>
                    </template>
                    <template v-else>
                      <p class="text">
                        <v-icon name="times" class="nok" />
                        {{ $t('numeroRaccordementEpEu') }}
                      </p>
                    </template>
                  </p>
                  <p class="text">
                    <template v-if="this.getValue(conformiteForm.infiltrerPartieEP)">
                      <v-icon name="check" />
                    </template>
                    <template v-else>
                      <v-icon name="times" class="nok" />
                    </template>
                    {{ $t('infiltrerPartieEP') }}
                  </p>
                  <p class="text">
                    <template v-if="this.getValue(conformiteForm.recupererPartieEP)">
                      <v-icon name="check" />
                    </template>
                    <template v-else>
                      <v-icon name="times" class="nok" />
                    </template>
                    {{ $t('recupererPartieEP') }}
                  </p>
                  <p class="text">
                    <template v-if="this.getValue(conformiteForm.reconnecterEpGargouille)">
                      <v-icon name="check" />
                    </template>
                    <template v-else>
                      <v-icon name="times" class="nok" />
                    </template>
                    {{ $t('reconnecterEpGargouille') }}
                  </p>
                  <p class="text">
                    <template v-if="this.getValue(conformiteForm.reconnecterEpExistEp)">
                      <v-icon name="check" />
                    </template>
                    <template v-else>
                      <v-icon name="times" class="nok" />
                    </template>
                    {{ $t('reconnecterEpExistEp') }}
                  </p>
                  <p class="text">
                    <template v-if="this.getValue(conformiteForm.realisationBranchementEpNeuf)">
                      <v-icon name="check" />
                    </template>
                    <template v-else>
                      <v-icon name="times" class="nok" />
                    </template>
                    {{ $t('realisationBranchementEpNeuf') }}
                  </p>
                  <p class="text">
                    <template v-if="this.getValue(conformiteForm.reseauSeparatif)">
                      <v-icon name="check" />
                    </template>
                    <template v-else>
                      <v-icon name="times" class="nok" />
                    </template>
                    {{ $t('reseauSeparatif') }}
                  </p>
                  <div
                    class="block"
                    v-if="conformiteForm.raccordementEpEu == isShown('reseauSeparatif')"
                  >
                    <p class="text">
                      {{ $t('surfaceParcelle') }}
                      <span>{{ `${new Intl.NumberFormat().format( conformiteForm.surfaceParcelle)}` }}</span>
                    </p>
                    <p class="text">
                      {{ $t('surfaceCollecte') }}
                      <span>{{ `${new Intl.NumberFormat().format( conformiteForm.surfaceCollecte)}` }}</span>
                    </p>
                    <p class="text">
                      <template v-if="this.getValue(conformiteForm.derogationAccorde)">
                        <v-icon name="check" />
                      </template>
                      <template v-else>
                        <v-icon name="times" class="nok" />
                      </template>
                      {{ $t('derogationAccorde') }}
                    </p>
                  </div>
                </div>
              </div>

        </div>
        <div class="panel panel-info text-left mg-b-0">
          <div class="panel-heading">{{ $t('domesticReject') }}</div>
          <div class="panel-body">
              <p class="text">
                {{ $t('eauxUseesTransitentGouttiere') }}
                <span>{{ getValueOf(conformiteForm.eauxUseesTransitentGouttiere) }}</span>
              </p>
              <p class="text">
                {{ $t('eauxUseesProlongeesEvents') }}
                <span>{{ getValueOf(conformiteForm.eauxUseesProlongeesEvents) }}</span>
              </p>
              <p class="text">
                {{ $t('eauxUseesRaccordeesRpu') }}
                <span>{{ getValueOf(conformiteForm.eauxUseesRaccordeesRpu) }}</span>
              </p>
              <p class="text">
                {{ $t('etancheiteRespectee') }}
                <span>{{ getValueOf(conformiteForm.etancheiteRespectee) }}</span>
              </p>
              <p class="text">
                {{ $t('sanitairesSiphonne') }}
                <span>{{ getValueOf(conformiteForm.sanitairesSiphonne) }}</span>
              </p>
              <p class="text">
                {{ $t('sanitairesSousNiveauChaussee') }}
                <span>{{ getValueOf(conformiteForm.sanitairesSousNiveauChaussee) }}</span>
              </p>
              <p class="text">
                {{ $t('installationProtectionReflux') }}
                <span>{{ getValueOf(conformiteForm.installationProtectionReflux) }}</span>
              </p>
              <p class="text">
                {{ $t('appareilsInterditReglement') }}
                <span>{{ getValueOf(conformiteForm.appareilsInterditReglement) }}</span>
              </p>
              <div
                class="block"
                v-if="conformiteForm.appareilsInterditReglement == isShown('appareilsInterditReglement')"
              >
                <p class="text">
                  {{ $t('appareilsInterditReglementText') }}
                  <span>{{ conformiteForm.appareilsInterditReglementText }}</span>
                </p>
              </div>
              <p class="text">
                {{ $t('gestionEpParcelle') }}
                <span>{{ getValueOf(conformiteForm.gestionEpParcelle) }}</span>
              </p>
              <div
                class="block"
                v-if="conformiteForm.gestionEpParcelle == isShown('gestionEpParcelle')"
              >
                <p class="text">
                  {{ $t('gestionEpParcelleSelection') }}
                  <span>{{ getGestionEpParcelleSelection() }}</span>
                </p>
                <p class="text">
                  {{ $t('rejetDomestiqueBonFonctionnement') }}
                  <span>{{ getValueOf(conformiteForm.rejetDomestiqueBonFonctionnement) }}</span>
                </p>
                <p class="text">
                  {{ $t('rejetDomestiqueAccessible') }}
                  <span>{{ getValueOf(conformiteForm.rejetDomestiqueAccessible) }}</span>
                </p>
                <p class="text">
                  {{ $t('rejetDomestiqueEntretenu') }}
                  <span>{{ getValueOf(conformiteForm.rejetDomestiqueEntretenu) }}</span>
                </p>
              </div>
              <p class="text">
                {{ $t('rejetDomestiqueRemarque') }}
                <span>{{ conformiteForm.rejetDomestiqueRemarque }}</span>
              </p>
            </div>
          </div>
        </div>
        <div class="panel panel-info text-left mg-b-0">
          <div class="panel-heading">{{ $t('rejetNonDomestique') }}</div>
          <div class="panel-body">
            <p class="text">
              {{ $t('activiteRestauration') }}
              <span>{{ getValueOf(conformiteForm.activiteRestauration) }}</span>
            </p>
            <p class="text">
              {{ $t('activiteGarageLavage') }}
              <span>{{ conformiteForm.activiteGarageLavage }}</span>
            </p>
            <p class="text">
              {{ $t('parking') }}
              <span>{{ getValueOf(conformiteForm.parking) }}</span>
            </p>
            <div class="block" v-if="conformiteForm.parking == isShown('parking')">
              <p class="text">
                {{ $t('parkingNbPlace') }}
                <span>{{ conformiteForm.parkingNbPlace }}</span>
              </p>
            </div>
            <p class="text">
              {{ $t('autreActiviteNonDomestiques') }}
              <span>{{ getValueOf(conformiteForm.autreActiviteNonDomestiques) }}</span>
            </p>
            <div
              class="block"
              v-if="conformiteForm.autreActiviteNonDomestiques == isShown('autreActiviteNonDomestiques')"
            >
              <p class="text">
                {{ $t('autreActiviteNonDomestiquesText') }}
                <span>{{ conformiteForm.autreActiviteNonDomestiquesText }}</span>
              </p>
            </div>
            <p class="text">
              {{ $t('equipementsPretraitement') }}
              <span>{{ getValueOf(conformiteForm.equipementsPretraitement) }}</span>
            </p>
            <div
              class="block"
              v-if="conformiteForm.equipementsPretraitement == isShown('equipementsPretraitement')"
            >
              <p class="text">
                {{ $t('equipementsPretraitementSelection') }}
                <span>{{ getEquipementsPretraitementSelection() }}</span>
              </p>
              <p class="text">{{ $t('infoEquipement') }}</p>
              <div class="block">
                <p class="text">
                  {{ $t('rejetNonDomestiqueBonFonctionnement') }}
                  <span>{{ getValueOf(conformiteForm.rejetNonDomestiqueBonFonctionnement) }}</span>
                </p>
                <p class="text">
                  {{ $t('rejetNonDomestiqueAccessible') }}
                  <span>{{ getValueOf(conformiteForm.rejetNonDomestiqueAccessible) }}</span>
                </p>
                <p class="text">
                  {{ $t('rejetNonDomestiqueEntretenu') }}
                  <span>{{ getValueOf(conformiteForm.rejetNonDomestiqueEntretenu) }}</span>
                </p>
              </div>
            </div>
            <p class="text">
              {{ $t('rejetNonDomestiqueRemarque') }}
              <span>{{ conformiteForm.rejetNonDomestiqueRemarque }}</span>
            </p>
          </div>
        </div>

      <div class="panel panel-info text-left">
        <div class="panel-heading">{{ $t('resume') }}</div>
        <div class="panel-body">
          <p class="text">
            {{ $t('controleRemarque') }}
            <span>{{ conformiteForm.controleRemarque }}</span>
          </p>
          <p>{{ getValueOf(conformiteForm.controlStatus) }}</p>
        </div>
      </div>

      <div class="panel panel-info text-left">
        <div class="panel-heading">{{ $t('technical_drawings') }}</div>
        <div class="panel-body">
            <div class="row">
              <div v-if="conformiteForm.technicalDrawingImage" class="col-sm-6">
                <h4 class="header-title">{{ $t('technical') }}</h4>
                <div class="text-center">
                  <img v-bind:src="getFileUrl(controlId, conformiteForm.technicalDrawingImage)" class="img-drawing">
                  <br>
                  <a v-bind:href="getFileUrl(controlId, conformiteForm.technicalDrawingImage)" target="_blank">{{ $t('download') }}</a>
                </div>
              </div>
              <div v-if="conformiteForm.synopticDrawingImage" class="col-sm-6 d-none">
                <h4 class="header-title">{{ $t('synoptic') }}</h4>
                <div class="text-center">
                  <img v-bind:src="getFileUrl(controlId, conformiteForm.synopticDrawingImage)" class="img-drawing">
                  <br>
                  <a v-bind:href="getFileUrl(controlId, conformiteForm.synopticDrawingImage)" target="_blank">{{ $t('download') }}</a>
                </div>
              </div>
            </div>
        </div>
      </div>

      <div class="panel panel-info text-left">
        <div class="panel-heading">{{ $t('signature') }}</div>
        <div class="panel-body">
          <div v-if="this.conformiteForm.signature !== null && this.conformiteForm.signature !== 'undefined'">
            <b>Signataire : </b>{{ this.conformiteForm.signator }}
            <br>
            <img v-bind:src="'/fr/file/' + this.controlId + '/preview/' + this.conformiteForm.signature"  class="signature"/>
            <br>
            {{ this.conformiteForm.signatureDateTime }}
          </div>
        </div>
      </div>

      <Workflow :controlForm="conformiteForm" />

        <SendControlAttachmentsToGed
        v-bind:dateOfVisit="conformiteForm.dateOfVisit"
        v-bind:control-id="controlId"
        v-bind:contract-id="contractId"
        v-bind:property-id="property.id"
        />

      <WorkflowHistory />

      <button v-show="canDeleteControl()"
        class="btn btn-danger s-btn-danger pull-right" v-on:click="deleteControl()"
      >{{ $t('deleteControl') }}</button>

      <div class="pull-right">&nbsp;</div>

      <button v-show="canEditControl()"
        class="btn btn-danger s-btn-danger pull-right" v-on:click="editControl()"
      >{{ $t('editControl') }}</button>

    </b-col>
  </b-row>
</template>
<script>
import { mapState, mapActions } from 'vuex';
import Workflow from '../Workflow';
import WorkflowHistory from '../WorkflowHistory';
import WorkflowTimeline from '../WorkflowTimeline';
import InfoBar from '../properties/InfoBar';
import FileDetail from './FileDetail';
import { VALUE_TRUE, VALUE_YES, VALUE_OTHER, VALUE_NO } from '../../constants/params';
import { formatDate } from '../../utils/formatDate';
import VueJwtDecode from 'vue-jwt-decode';
import SendControlAttachmentsToGed from './SendControlAttachmentsToGed';
import { getEndpoint } from '../../store/endpoints';
import axios from 'axios';

export default {
  Name: 'ConformiteDetail',
  components: {
    Workflow,
    InfoBar,
    FileDetail,
    WorkflowHistory,
    WorkflowTimeline,
    SendControlAttachmentsToGed,
  },
  data() {
    return {
      contractId: null,
      eServices: null,
    };
  },
  created() {
    this.getRequestConformiteById();
    this.initNotif();
  },
  mounted () {
    this.jwtDecoded = VueJwtDecode.decode(this.$store.state.app.parameters.jwt);
    this.contractId = this.jwtDecoded.data.user.contractsIds[0];
    this.eServices = this.jwtDecoded.data.user.eServices;
  },
  computed: {
    ...mapState({
      property: state => state.refProperties.property,
      conformiteForm: state => state.conformite.conformiteForm,
      controlId: state => state.route.params.controlId,
    }),
  },
  methods: {
    ...mapActions(['getRequestConformiteById', 'initNotif']),
    getValue(value) {
      return value == 1 ? true : false;
    },
    getValueOf(value) {
      const options = {
        oui: 'Oui',
        non: 'Non',
        impossible: 'Indéterminé',
        bacGraisse: 'Bac à graisse',
        separateurHydro: 'Séparateur à hydrocarbure',
        autre: 'Autre',
        'init-visit': 'Visite initiale',
        'cons-visit': 'Contre-visite',
        'visit-advice': 'Visite conseil',
        mutation: 'Mutation',
        separtif: 'Séparatif',
        other: 'Autre',
        conforme: 'CONFORME',
        'non-conforme': 'NON CONFORME',
        'non-conforme-sans-dysfonctionnement': 'NON CONFORME SANS DYSFONCTIONNEMENT',
      };
      return options[value];
    },

    getTypeOfInvestigation(value) {
      let arr = [
        {
          value: 'ac',
          text: 'AC',
        },
        {
          value: 'ar',
          text: 'AR',
        },
      ];
      let obj = arr.find(p => p.value === value);
      if (obj) {
        return obj.text;
      }
    },
    getEquipementsPretraitementSelection() {
      if (
        this.conformiteForm.equipementsPretraitementSelection &&
        this.conformiteForm.equipementsPretraitementSelection.length > 0
      ) {
        const equipments = this.conformiteForm.equipementsPretraitementSelection.map(item => this.getValueOf(item));
        return equipments.join();
      }
    },
    getGestionEpParcelleSelection() {
      if (this.conformiteForm.gestionEpParcelleSelection && this.conformiteForm.gestionEpParcelleSelection.length > 0) {
        const selection = this.conformiteForm.gestionEpParcelleSelection.map(item => item.name);
        return selection.join();
      }
    },
    getTypeOfControl() {
      if (this.conformiteForm.typeOfControl && this.conformiteForm.typeOfControl.length > 0) {
        const selection = this.conformiteForm.typeOfControl.map(item => item.label);
        return selection.join(', ');
      }
    },
    isShown: function(value) {
      const options = {
        reseauSeparatif: VALUE_TRUE,
        rejetDomestique: VALUE_TRUE,
        appareilsInterditReglement: VALUE_YES,
        gestionEpParcelle: VALUE_YES,
        rejetNonDomestique: VALUE_TRUE,
        parking: VALUE_YES,
        autreActiviteNonDomestiques: VALUE_YES,
        equipementsPretraitement: VALUE_YES,
        equipementsPretraitementSelection: VALUE_OTHER,
        raccordementEuEp: VALUE_TRUE,
        raccordementEpEu: VALUE_TRUE,
        eauxUseesEtPluvialesSeparees: VALUE_NO,
      };
      return options[value];
    },
    formatDate(value) {
      return formatDate(value);
    },
    onCancel() {
      this.$router.push({ name: `property_detail`, params: { propertyId: this.property.id } });
    },
    getFileUrl: function (requestId, fileId) {
      // Get diagrams file content (xml, and base64 for images) and set diagrams fields values
      return getEndpoint('file', null, requestId, fileId, null).absoluteDownloadUrl;
    },
    deleteControl() {
      if (! confirm(this.$t('delete_control_confirmation_message'))) {
        return false;
      }

      let endpoint = getEndpoint('conformite', null, this.$route.params.controlId, null).delete;
      let _this = this;

      axios.delete(endpoint).then(function () {
        _this.$router.push({
          name: `controls`,
        });
      });
    },
    canDeleteControl() {
      if (this.contractId) {
        if (this.eServices[this.contractId]['CONTROLES']['DELETE'] === true) {
          return true;
        }
      }

      return false;
    },
    editControl() {
      this.$router.push({
        name: `conformite_edit`,
        params: { controlId: this.$route.params.controlId, propertyId: this.$route.params.propertyId },
      });
    },
    canEditControl() {
      if (this.contractId) {
        if (this.eServices[this.contractId]['CONTROLES']['EDIT'] === true) {
          return true;
        }
      }

      return false;
    },
  },
};
</script>

<style scoped>
.img-drawing {
  height: 200px;
}
</style>
